var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.86719 17.6001C5.86719 16.0441 6.48528 14.5519 7.58549 13.4517C8.68571 12.3515 10.1779 11.7334 11.7339 11.7334H29.3339C30.8898 11.7334 32.382 12.3515 33.4822 13.4517C34.5824 14.5519 35.2005 16.0441 35.2005 17.6001V41.0667C35.2005 42.6227 34.5824 44.1149 33.4822 45.2151C32.382 46.3153 30.8898 46.9334 29.3339 46.9334H11.7339C10.1779 46.9334 8.68571 46.3153 7.58549 45.2151C6.48528 44.1149 5.86719 42.6227 5.86719 41.0667V17.6001ZM42.6893 20.8443C42.2021 21.0878 41.7924 21.462 41.5059 21.9252C41.2194 22.3884 41.0675 22.9221 41.0672 23.4667V35.2001C41.0675 35.7447 41.2194 36.2785 41.5059 36.7416C41.7924 37.2048 42.2021 37.579 42.6893 37.8225L48.556 40.7558C49.0031 40.9792 49.4999 41.0847 49.9992 41.0622C50.4985 41.0397 50.9838 40.89 51.409 40.6273C51.8342 40.3646 52.1852 39.9976 52.4287 39.5611C52.6723 39.1247 52.8002 38.6332 52.8005 38.1334V20.5334C52.8002 20.0336 52.6723 19.5421 52.4287 19.1057C52.1852 18.6692 51.8342 18.3022 51.409 18.0395C50.9838 17.7768 50.4985 17.6271 49.9992 17.6046C49.4999 17.5821 49.0031 17.6876 48.556 17.911L42.6893 20.8443Z",
    fill: "url(#paint0_linear_2205_35424)",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2205_35424",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 11,
    width: 48,
    height: 36
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.86719 17.6001C5.86719 16.0441 6.48528 14.5519 7.58549 13.4517C8.68571 12.3515 10.1779 11.7334 11.7339 11.7334H29.3339C30.8898 11.7334 32.382 12.3515 33.4822 13.4517C34.5824 14.5519 35.2005 16.0441 35.2005 17.6001V41.0667C35.2005 42.6227 34.5824 44.1149 33.4822 45.2151C32.382 46.3153 30.8898 46.9334 29.3339 46.9334H11.7339C10.1779 46.9334 8.68571 46.3153 7.58549 45.2151C6.48528 44.1149 5.86719 42.6227 5.86719 41.0667V17.6001ZM42.6893 20.8443C42.2021 21.0878 41.7924 21.462 41.5059 21.9252C41.2194 22.3884 41.0675 22.9221 41.0672 23.4667V35.2001C41.0675 35.7447 41.2194 36.2785 41.5059 36.7416C41.7924 37.2048 42.2021 37.579 42.6893 37.8225L48.556 40.7558C49.0031 40.9792 49.4999 41.0847 49.9992 41.0622C50.4985 41.0397 50.9838 40.89 51.409 40.6273C51.8342 40.3646 52.1852 39.9976 52.4287 39.5611C52.6723 39.1247 52.8002 38.6332 52.8005 38.1334V20.5334C52.8002 20.0336 52.6723 19.5421 52.4287 19.1057C52.1852 18.6692 51.8342 18.3022 51.409 18.0395C50.9838 17.7768 50.4985 17.6271 49.9992 17.6046C49.4999 17.5821 49.0031 17.6876 48.556 17.911L42.6893 20.8443Z",
    fill: "#1D1E1E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2205_35424)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.9667,
    cy: 40.7001,
    rx: 17.9667,
    ry: 17.9667,
    fill: "url(#paint1_linear_2205_35424)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.4667,
    cy: 43.6333,
    rx: 23.4667,
    ry: 21.6333,
    fill: "url(#paint2_linear_2205_35424)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5682,
    cy: 18.7001,
    r: 17.9667,
    fill: "url(#paint3_linear_2205_35424)",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2205_35424",
    x1: 43.2735,
    y1: 11.7334,
    x2: 11.1682,
    y2: 35.5236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A64FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6370E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2205_35424",
    x1: 61.6392,
    y1: 22.7334,
    x2: 32.5471,
    y2: 38.9015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A64FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6370E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2205_35424",
    x1: 37.4063,
    y1: 22,
    x2: 0.929227,
    y2: 43.9903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A64FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6370E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2205_35424",
    x1: 46.2407,
    y1: 0.733401,
    x2: 17.1487,
    y2: 16.9015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A64FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6370E7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareLink);
export default __webpack_public_path__ + "static/media/share-link.e656a699fa8536ab75b409e95d3c3ca7.svg";
export { ForwardRef as ReactComponent };